import React, { type ReactElement } from 'react';
import { toast } from 'react-toastify';
import ConfirmModal, { ConfirmModalActionPair } from 'atom-components/confirm-modal';
import { refreshMarkingTables } from 'pages/marking/helpers/react-query.helpers';
import { useDeleteTestInstanceResponseMark } from 'services/assist-api/entities/test-instance-response-mark/hooks';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  markId: number;
};

export default function ConfirmDeleteMarkModal({
  isOpen,
  onClose,
  onConfirm,
  markId
}: Props): ReactElement {
  const deleteTestInstanceResponseMark = useDeleteTestInstanceResponseMark({
    onSuccess: () => {
      toast.success('Mark has been deleted.');
      refreshMarkingTables();
      if (onConfirm) {
        onConfirm();
      }
    },
    onError: (error) => {
      toast.error(`Error deleting mark: ${error.message}`);
    },
    onSettled: () => {
      onClose();
    }
  });

  return (
    <ConfirmModal
      isOpen={isOpen}
      title="Confirm Delete Mark"
      handleClickCancel={onClose}
      handleClickOK={(): void => deleteTestInstanceResponseMark.mutate(markId)} // Todo: Refresh deallocation results
      actionPair={ConfirmModalActionPair.Custom}
      buttonTitleOK="Confirm Delete Mark"
      buttonTitleCancel="Cancel"
    >
      Are you sure that you want to delete <b>mark #{markId}</b>? This cannot be undone.
    </ConfirmModal>
  );
}
